exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content .not-found-img[data-v-1ff7eaab] {\n  width: 80%;\n  display: block;\n  margin: 0.5rem auto;\n}\n.content .show-text[data-v-1ff7eaab] {\n  width: 90%;\n  margin: 0.3rem auto;\n  text-align: center;\n  color: grey;\n  font-size: 0.3rem;\n}\n", ""]);

// exports
